<template>
  <div class="product-images">
    <v-row no-gutters>
      <v-col cols="12" md="12" class="d-flex justify-center">
        <!-- product code visualizzato su phone -->
        <span v-html="code" class="product-code mobile hidden-sm-and-up"></span>
        <div class="favourite">
          <v-tooltip left :key="heartKey">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                icon
                @click.stop.prevent="toggleFavourites"
                @mousedown.stop
              >
                <v-icon color="primary" v-if="highlight">$heartFull</v-icon>
                <v-icon v-else class="heart">$heart</v-icon>
              </v-btn>
            </template>
            <span v-if="highlight">Articolo presente in una tua lista</span>
            <span v-else>Aggiungi ad una lista</span>
          </v-tooltip>
        </div>
        <div
          :style="{
            width: $vuetify.breakpoint.xs ? '100%' : '400px'
          }"
        >
          <img
            class="mt-2"
            v-if="$vuetify.breakpoint.xs"
            :src="selectedImage.medium"
            :alt="'Immagine prodotto ' + name"
            @click.stop="dialog = true"
          />
          <zoom-on-hover
            v-else
            :scale="1.5"
            :img-normal="selectedImage.medium"
            :img-zoom="selectedImage.large"
          ></zoom-on-hover>
        </div>
      </v-col>

      <v-col
        cols="12"
        md="12"
        class="d-flex justify-center thumb-wrapper"
        v-if="images.length > 1"
      >
        <swiper :options="swiperOptionThumbs" class="swiper" ref="swiperThumb">
          <swiper-slide v-for="media in images" :key="media.medium">
            <img
              :key="'img_' + media.medium"
              :src="media.small"
              :alt="'Anteprima immagine prodotto ' + name"
              :class="{ selected: selectedImage == media }"
              @click="selectedImage = media"
            />
          </swiper-slide>
        </swiper>
        <div class="swiper-button-next" slot="button-next"></div>
        <div class="swiper-button-prev" slot="button-prev"></div>
      </v-col>
    </v-row>
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      class="zoom-dialog"
    >
      <div class="zoom-dialog-content">
        <v-btn @click.stop="dialog = false" dense elevation="0">Chiudi</v-btn>
        <pinch-zoom height="100%">
          <img :src="selectedImage.large" />
        </pinch-zoom>
      </div>
    </v-dialog>
  </div>
</template>
<script>
import PinchZoom from "vue-pinch-zoom";

export default {
  name: "ProductImages",
  props: {
    images: { type: Array, required: true },
    name: { type: String, required: false },
    code: { type: String, required: false },
    highlight: { type: Boolean, required: false },
    heartKey: { type: Number, required: false }
  },
  components: { PinchZoom },
  data() {
    return {
      selectedImage: {},
      dialog: false,
      swiperOptionThumbs: {
        slidesPerView: 4,
        slidesPerGroup: 1,
        spaceBetween: 10,
        watchOverflow: true,
        threshold: 10,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        breakpoints: {
          320: {
            slidesPerView: 3
          },
          600: {
            slidesPerView: 5
          },
          960: {
            slidesPerView: 3
          },
          1280: {
            slidesPerView: 4
          },
          1590: {
            slidesPerView: 4
          }
        }
      }
    };
  },
  computed: {
    medium() {
      return this.selectedImage && this.selectedImage.medium;
    },
    large() {
      return this.selectedImage && this.selectedImage.large;
    }
  },
  methods: {
    openZoom() {},
    toggleFavourites() {
      this.$emit("toggleFavourites");
    }
  },
  mounted() {
    this.selectedImage = this.images[0];
  }
};
</script>

<style></style>
